import { render } from "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=template&id=c75512c2&scoped=true"
import script from "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=style&index=0&id=c75512c2&scoped=true&lang=css"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c75512c2"]])

export default __exports__